import { ReactNode } from 'react';

import * as Styled from './activity-builder-slide.style';
import { useSlideResize } from './activity-builder-slide.hooks';

const ActivityBuilderSlide = ({ children }: { children: ReactNode }) => {
  const { ref } = useSlideResize();

  return (
    <Styled.ActivityBuilderSlideRow ref={ref}>
      <Styled.ActivityBuilderSlide>
        <Styled.ActivityBuilderSlideContent $paddingTop={0}>
          {children}
        </Styled.ActivityBuilderSlideContent>
      </Styled.ActivityBuilderSlide>
    </Styled.ActivityBuilderSlideRow>
  );
};

export default ActivityBuilderSlide;
